import * as stylex from "@stylexjs/stylex";
import { ChevronsDownUp, ChevronsUpDown } from "lucide-react";
import { copy } from "@/copy";
import type { Clock } from "@/domain/time";
import "@/theme/tokens.stylex";
import { colors, motion } from "@/theme/tokens.stylex";
import "@/theme/type.stylex";
import { type } from "@/theme/type.stylex";
import { Icon } from "@/ui/Icon";
import { press } from "@/ui/press";
type SpanLinkProps = {
  on: boolean;
  outside: number;
  clock: Clock;
  onToggle: () => void;
};
const styles = {
  link: {
    kAzted: "x21xpn4",
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kOIVth: "x1jnr06f",
    k8WAf4: "xt970qd",
    kg3NbH: "xdqyycr",
    kMzoRj: "xc342km",
    kWkggS: "xjbqb8w",
    kMwMTN: "x1a11ngh",
    kMv6JI: "x17jlq2w",
    kGuDYH: "xif65rj",
    k63SB2: "x1cf7cre",
    kMnn75: "xujl8zx",
    kNySMw: "xyi4chj",
    kcSHmL: "x3pynha",
    kkrTdU: "x1ypdohk",
    k1ekBW: "x11xpdln",
    kIyJzY: "x1bpocu2",
    kAMwcw: "x1em5f5i",
    $$css: true
  }
};
export function SpanLink({
  on,
  outside,
  clock,
  onToggle
}: SpanLinkProps) {
  return <div className="x78zum5 xl56j7k x9otpla x4vbgl9">
      <button type="button" aria-pressed={on} onClick={onToggle} {...stylex.props(styles.link, press.scale)}>
        {on ? copy.calendar.showDayHours(clock) : copy.calendar.showAllHours(outside)}
        <Icon icon={on ? ChevronsDownUp : ChevronsUpDown} size={14} />
      </button>
    </div>;
}